import { SERVICE_GROUPS } from "../constants/service_groups";

/** `translateGroup` receives keys like `administration_et_gestion` or `autres`. */
export function createServiceGroupBy(
  translateGroup: (groupKey: string) => string,
): (item: { slug: string }) => string {
  return (item) => {
    for (const [groupKey, slugs] of Object.entries(SERVICE_GROUPS)) {
      if (slugs.includes(item.slug)) {
        return translateGroup(groupKey);
      }
    }
    return translateGroup("autres");
  };
}
